<template>
  <article class="homepage">
    <div class="container">
      <HeroesMainHero
        v-if="hero && (hero.title?.value || hero.body?.value)"
        :main-hero="{
          intro: {
            icon: hero.icon ?? null,
            title: hero.title ?? null,
            body: hero.body ?? null,
          },
          img: hero.image,
          article: hero.links,
        }" />
      <div class="content-block two-column-text">
        <h1 v-if="title && title.value" v-bind="useEpiAttrs(title)">{{ title?.value }}</h1>
        <BlocksWerkenbijContentArea v-if="body && body.value" :content="body" />
      </div>
      <div class="content-block-full homepage-slider">
        <div class="container">
          <div class="content-block">
            <h1
              v-if="personsBlockTitle && personsBlockTitle.value"
              v-bind="useEpiAttrs(personsBlockTitle)">
              {{ personsBlockTitle?.value }}
            </h1>
          </div>
        </div>
        <SlidersColleagueSlider v-if="persons" :data="persons" :icon="hero?.icon" />
      </div>
    </div>
  </article>
</template>

<script lang="ts" setup>
import type { ContentResponseModel, WerkenbijHomePageResponseModel } from '@api';

const props = defineProps<{ data: ContentResponseModel }>();
const { hero, body, title, personsBlockTitle, persons } = props.data
  .content as WerkenbijHomePageResponseModel;
</script>

<style lang="scss" scoped>
.homepage {
  h1 {
    color: var(--color-navy-blue);
  }

  .two-column-text {
    grid-row: 2 / 3;

    h1 {
      color: var(--color-navy-blue);
    }

    .btn {
      &--big {
        page-break-inside: avoid;
        break-inside: avoid-column;
      }
    }

    @include media-breakpoint-up(lg) {
      column-count: 2;
      column-gap: px(30);
    }
  }

  .homepage-slider {
    background-color: var(--color-bg-blue);
    grid-row: 3 / 4;
    padding: 0 0 px(30);

    .container {
      padding-top: px(24);
    }

    .content-block {
      padding-bottom: 0;
    }

    h1 {
      color: var(--color-navy-blue);
    }

    @include media-breakpoint-up(lg) {
      padding: px(64) 0 px(32);

      .container {
        padding-top: 0;
      }
    }
  }
}
</style>
